import React from 'react';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Styles from './ExperienceCard.styles';
import Text from '../Text';
import FluidImageWrapper from '../FluidImageWrapper';
import ImageFluid from '../ImageFluid';
import MoreImage from '../../../assets/images/Card/more.svg';

const Container = styled.div`
  ${Styles.container};
`;
const GradientLayer = styled.div`
  ${Styles.gradientLayer}
`;
const InnerWrapper = styled.div`
  ${Styles.innerWrapper}
`;
const Title = styled(Text)`
  ${Styles.title};
`;
const More = styled.a`
  ${Styles.more};
`;
const MainExperience = styled.div`
  ${Styles.mainExperience}
`;
const SecondaryExperience = styled.div`
  ${Styles.secondaryExperience}
`;
const Abstract = styled.div`
  ${Styles.abstract};
`;
/**
 * Experience Card pure component
 * @param  {string} title Titulo de la tarjeta
 * @param  {string} url url del post
 * @param  {string} content resumen
 * @returns {JSX}
 */
const ExperienceCard = ({
  title,
  image,
  content,
  gradientColor,
  className,
  height,
  slug,
  locale
}) => {
  /**
   * Wrapper for secondary componente elements
   * @param {*} props props for the component
   * @returns {JSX} component
   */
  let Wrapper = ({ children }) => (
    <SecondaryExperience>{children}</SecondaryExperience>
  );
  if (height === 1) {
    Wrapper = ({ children }) => <MainExperience>{children}</MainExperience>;
  }
  return (
    <Container backgroundImage={image} className={className} gradientColor={gradientColor}>
      <Wrapper>
        <InnerWrapper>
          <Link to={`/${locale}${slug}`}>
            <Title tag="h3" className="cbx-bold"> {title}</Title>
            <Abstract>{content}</Abstract>
            <More href={`/${locale}${slug}`}>
              <img src={MoreImage} alt={title} />
            </More>
          </Link>
        </InnerWrapper>
      </Wrapper>
      <Link to={`/${locale}${slug}`}>
        <GradientLayer gradientColor={gradientColor} className="gradient-layer" />
        <FluidImageWrapper>
          <ImageFluid fluid={image} />
        </FluidImageWrapper>
      </Link>
    </Container>
  );
};
ExperienceCard.propTypes = {
  gradientColor: PropTypes.oneOf(['pink', 'aqua', 'purple', 'yellow', 'green']),
  content: PropTypes.string,
  title: PropTypes.string,
  image: PropTypes.object,
  className: PropTypes.string,
  slug: PropTypes.string,
  locale: PropTypes.string,
  height: PropTypes.number
};

export default ExperienceCard;
